<template>
  <div id='app'>
    <div id="url_expired">
      <h4>Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div id="url_valid">
      <div style="text-align: center;">
        <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
        <div>{{userDetails.address}}</div>
        *****
        <div id="location_not_null">
          Sorry! Your location is already updated, if you want to change your delivery location then please change it from doodhvale app.
        </div>
        <div id="location_null">
          <!-- <input class="button2" value="Current Location" type="button" v-on:click="onClickCurrentLocationButtion();"> -->
          <br>
          <div id="floating-panel" @click="onClickCurrentLocationButtion();">
            <img src="../../../../static/img/currentlocation.png" style="width:17%;">
          </div>
          <!-- <div @click="onClickCurrentLocationButtion"><img style="width: 20px; height: 20px;" src="/../../../../static/img/currentlocation.png"></div> -->
          <gmap-map v-bind:center='center' v-bind:zoom='14' style='height: 250px'>
            <gmap-marker v-bind:key='index' v-for='(m, index) in markers' v-bind:position='m.position' v-bind:clickable='true' v-bind:draggable="true" @drag="updateCoordinates"></gmap-marker>
          </gmap-map><br>
          <!-- <input class="button1" value="Click to Current Location" type="button" v-on:click="onClickCurrentLocationButtion();"> -->
          <input class="button1" value="Update Delivery Location" type="button" v-on:click="latLngCheck();">
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        deliveryLocObj: [],
        center: { lat: 0, lng: 0 },
        markers: [
          {
            position: { lat: 0, lng: 0 }
          }
        ]
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('l?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'location_url':
              this.apiDataObj.userId = response.data.action_response.user_id
              this.apiDataObj.pincode = response.data.action_response.pincode
              if (response.data.action_response.lat != null && response.data.action_response.lng != null) {
                document.getElementById('location_null').style.display = 'none'
                document.getElementById('location_not_null').style.display = 'block'
              } else {
                document.getElementById('location_not_null').style.display = 'none'
                document.getElementById('location_null').style.display = 'block'
                this.fetchCurrentLocation()
              }
              this.userInfo()
              break
            default:
              break
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      fetchCurrentLocation () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            this.center.lat = pos.lat
            this.center.lng = pos.lng
            this.markers[0].position.lat = pos.lat
            this.markers[0].position.lng = pos.lng
            // this.geocodeLatLng(new google.maps.Geocoder, pos, google.maps.InfoWindow);
          }.bind(this))
        }
      },
      onClickCurrentLocationButtion () {
        // this.fetchCurrentLocation()
        window.location.reload()
      },
      updateCoordinates (location) {
        this.markers[0].position.lat = location.latLng.lat()
        this.markers[0].position.lng = location.latLng.lng()
      },
      latLngCheck () {
        if (this.markers[0].position.lat !== 0 && this.markers[0].position.lng !== 0) {
          var answer = confirm('Do you want to update delivery location?')
          if (answer) {
            this.onClickUpdateLocation()
          }
        } else {
          alert('Cant update location. Please enable your location from Browser settings')
        }
      },
      onClickUpdateLocation () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        var userPincode = this.apiDataObj.pincode
        var userLat = this.markers[0].position.lat
        var userLng = this.markers[0].position.lng
        params.append('customer_id', userId)
        params.append('latitude', userLat)
        params.append('longitude', userLng)
        params.append('pincode', userPincode)
        axios({
          url: process.env.BASE_API + '/deliveries/add-coordinate-map',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.deliveryLocObj = {}
          if (response.data.status === '000000') {
            alert('Your delivery location updated succussfully.')
          } else {
            alert('Opps! we have faced problem in updating your location. Retry again.')
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>

<style>
  .button1 {background-color: #3CB6C3; padding: 1% 5% 1% 5%;}
  .button2 {background-color: black; padding: 1% 5% 1% 5%; color: white;}
  #floating-panel {
    position: absolute;
    z-index: 5;
    margin: 4% 0% 5% 60%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/L.vue